import { useCallback } from 'react';

import { createStateSelectorHook } from 'src/lib/sweetState';
import { PerformanceStore } from 'src/store';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['accounts']);

export const useConnectedWebsiteAccount = () => {
  const { accounts } = usePerformanceState();

  return useCallback(
    (channel) => {
      const account = accounts[channel]?.find((a) => a.isConnected) || {};

      return {
        titles: account?.pageTitles,
        ...account,
      };
    },
    [accounts]
  );
};
